// extracted by mini-css-extract-plugin
export default {"root":"NewArticle_root__tmBo4","form":"NewArticle_form__gUWRi","footer":"NewArticle_footer__DgB1y","richText":"NewArticle_richText__8EehJ"};